import Header2 from './Header2'
export default Header2
